'use client';
import { useState } from 'react';

const downloadBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = url;
  a.download = filename;
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

const useSaveUrlFile = (): {
  isLoading: boolean;
  saveUrlFile: (href: string, title?: string) => Promise<void>;
  saveBlobFile: (blob: Blob, title: string) => Promise<void>;
} => {
  const [isLoading, setIsLoading] = useState(false);

  const saveUrlFile = async (href: string, title?: string): Promise<void> => {
    setIsLoading(true);
    try {
      const response = await fetch(href, {
        method: 'GET',
        headers: {},
      });
      const buffer = await response.arrayBuffer();
      const filename = title || href.split('/').slice(-1)[0].split('?')[0];
      downloadBlob(new Blob([buffer]), filename);
    } finally {
      setIsLoading(false);
    }
  };

  const saveBlobFile = (blob: Blob, title: string): Promise<void> => {
    setIsLoading(true);
    try {
      downloadBlob(blob, title);
    } finally {
      setIsLoading(false);
    }

    return Promise.resolve();
  };

  return { isLoading, saveUrlFile, saveBlobFile };
};

export default useSaveUrlFile;
